export default __webpack_public_path__ + "static/media/home_settings_icon.a027018a.svg";